export class PageFeedback {
    static init(): void {
        this.setEventHandlers();
    }

    private static setEventHandlers(): void {
        const feedbackQuestion = document.querySelector<HTMLElement>('.feedback-question');
        const feedbackOptions = document.querySelector<HTMLElement>('.feedback-options');
        const feedbackYes = document.querySelector<HTMLElement>('.feedback-yes');
        const feedbackNo = document.querySelector<HTMLElement>('.feedback-no');
        const feedbackResponseYes = document.querySelector<HTMLElement>('.feedback-thank-you');
        const feedbackResponseNo = document.querySelector<HTMLElement>('.feedback-improve');

        feedbackYes?.addEventListener('click', () => {
            feedbackResponseYes?.classList.toggle('hidden');
            feedbackQuestion?.remove();
            feedbackOptions?.remove();
        });

        feedbackNo?.addEventListener('click', () => {
            feedbackResponseNo?.classList.toggle('hidden');
            feedbackQuestion?.remove();
            feedbackOptions?.remove();
        });

    }
}

